import * as Yup from 'yup';
import "./yupSchema.d.ts";

export default Yup;